export enum StorageKeys {
  AuthToken = '@ryddm/authToken',
  SentPasswordResetEmailDate = '@ryddm/sentPasswordResetDate',
  SentVerificationEmailDate = '@ryddm/sentVerificationEmailDate',
}
